import { defineStore } from "pinia";
import {
  IDriverStatusFilter,
  INewDriverStatus,
} from "@/features/driver-status/driver-status.types";
import { Ref, ref } from "vue";
import { ITableHeader } from "@/types/table";
import { driverStatusService } from "@/features/driver-status/driver-status.service";
import { useNotification } from "@/utils/notification";

const { pushNotification } = useNotification();

export const useDriverStatusStore = defineStore("driver-status", () => {
  const commonFilter = ref<IDriverStatusFilter>({
    status: "",
    team_id: "",
    company_id: "",
    driver_id: "",
    target_status: "",
    search: "",
    page: 1,
    per_page: 50,
  });

  const clearFilter = () => {
    commonFilter.value = {
      status: "",
      team_id: "",
      company_id: "",
      driver_id: "",
      target_status: "",
      search: "",
      page: 1,
      per_page: 50,
    };
  };

  const driverStatusHeaders: ITableHeader[] = [
    {
      name: "id",
      label: "No",
      width: "3%",
    },
    {
      name: "company_name",
      label: "Company name",
      width: "18%",
    },
    {
      name: "driver_name",
      label: "Drivers",
      width: "18%",
    },
    {
      name: "created_by_name",
      label: "Created By",
      width: "14%",
    },
    {
      name: "eld_status",
      label: "ELD status",
      width: "15%",
    },
    {
      name: "last_seen_status",
      label: "Current ELD status",
      width: "10%",
    },
    {
      name: "status",
      label: "Status",
      width: "7%",
    },
    {
      name: "expires_time",
      label: "Expire time",
      width: "7%",
    },
    {
      name: "actions",
      label: "Actions",
      width: "8%",
    },
  ];

  async function getDriverStatusList(loading: Ref<boolean>, cl: any) {
    loading.value = true;
    await driverStatusService
      .getDriverStatusWatches({ ...commonFilter.value })
      .then((res: any) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function createNewDriverStatus(
    loading: Ref<boolean>,
    payload: INewDriverStatus,
    cl: any
  ) {
    loading.value = true;
    await driverStatusService
      .createDriverStatusWatch(payload)
      .then((res: any) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function cancelWatch(loading: Ref<boolean>, watchId: string, cl: any) {
    loading.value = true;
    await driverStatusService
      .cancelDriverStatusWatch(watchId)
      .then((res: any) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  async function checkWatch(loading: Ref<boolean>, watchId: string, cl: any) {
    loading.value = true;
    await driverStatusService
      .checkDriverStatusWatch(watchId)
      .then((res: any) => {
        cl(res.data);
      })
      .catch((err) => {
        pushNotification(err.response?.data?.detail || err, "error");
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    commonFilter,
    driverStatusHeaders,
    clearFilter,
    getDriverStatusList,
    createNewDriverStatus,
    cancelWatch,
    checkWatch,
  };
});
